import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ControllersModule } from './controllers/controllers.module';
import { HomeModule } from './home/home.module';
import { LoginModule } from './login/login.module';
import { LogsModule } from './logs/logs.module';
import { ProducersModule } from './producers/producers.module';
import { UsersModule } from './users/users.module';
import { BreedersModule } from './breeders/breeders.module';
import { IntegrationSettingsModule } from './integration-settings/integration-settings.module';
import { IntegrationMonitorModule } from './integration-monitor/integration-monitor.module';
import { AdjustmentsAuditModule } from './adjustments-audit/adjustments-audit.module';

@NgModule({
    imports: [
        CommonModule,
        ControllersModule,
        HomeModule,
        LoginModule,
        LogsModule,
        ProducersModule,
        BreedersModule,
        UsersModule,
        IntegrationSettingsModule,
        IntegrationMonitorModule,
        AdjustmentsAuditModule
    ]
})
export class FeaturesModule {}
